/**
 * Round rating to nearest 0.5 for half star display
 */
export const roundToHalf = (value: number): number => {
  return Math.round(value * 2) / 2;
};

/**
 * Format average rating for display (e.g., "4.5" or "3.4")
 */
export const formatAverageRating = (rating: number | null | undefined): string => {
  if (rating == null) return '-';

  const rounded = Math.round(rating * 10) / 10;
  if (Number.isInteger(rounded)) {
    return rounded.toString();
  }
  return rounded.toFixed(1);
};

/**
 * Get rating category label in Croatian
 */
export const getRatingCategoryLabel = (category: 'adDescriptionAccuracy' | 'paymentAndExchangeAgreement' | 'communication' | 'honoringAgreement'): string => {
  switch (category) {
    case 'adDescriptionAccuracy':
      return 'Opis oglasa';
    case 'paymentAndExchangeAgreement':
      return 'Plaćanje / zamjena';
    case 'communication':
      return 'Komunikacija';
    case 'honoringAgreement':
      return 'Poštivanje dogovora';
    default:
      return '';
  }
};



// WEBPACK FOOTER //
// ./src/utils/ratingHelpers.ts